export default __webpack_public_path__ + "static/media/slider_image_01-xs@1x.b365de17.jpg";